import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { LogoProps } from '../types';
import { cn } from '@/lib/utils';

export const Logo: React.FC<LogoProps> = ({ variant = 'default', className }) => {
  const logoSrc = variant === 'white' ? '/mangia-logo-white.png' : '/mangia-logo-black.png';

  const logoClasses = cn(
    'w-8 sm:w-10 md:w-12 h-8 sm:h-10 md:h-12 transition-transform hover:scale-105 object-contain',
    {
      'filter brightness-0': variant === 'dark',
      'filter brightness-0 invert': variant === 'white',
    },
    className,
  );

  return (
    <Link href='/' className='flex-shrink-0'>
      <Image
        src={logoSrc}
        alt='Pushcola logo'
        width={48}
        height={48}
        className={logoClasses}
        priority
        style={{
          width: 'auto',
          height: 'auto',
          maxWidth: '100%',
          maxHeight: '100%',
        }}
      />
    </Link>
  );
};
